// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/kontaktschiene/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteKontaktschieneDE: PageEntry = {
  id: "example.produkte-kontaktschiene",
  locale: "de",
  slug: "produkte/kontaktschiene",
  seo: {
    title: "Kontaktschiene | Dietz GmbH",
    description: "Verbindungselement in Stromverteiler: Kombination von Stanz-Umformteilen, technischen Federn und Kunststoffformteile. Diese Baugruppen werden durch verschiedene Montageprozesse her",
  },
  type: "post",
  h1: "Kontaktschiene",
  intro: "Verbindungselement in Stromverteiler: Kombination von Stanz-Umformteilen, technischen Federn und Kunststoffformteile. Diese Baugruppen werden durch verschiedene Montageprozesse hergestellt (Fügen, Pressen, Löten)",
  blocks: [
    { kind: "image", src: "/images/live/dtz-kontaktschiene.jpg", alt: "Kontaktschiene", width: 1400, height: 1120 }
  ],
};
